module.exports = __webpack_public_path__ + "img/2.015ef691.jpg";